import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/Elements/ScrollToTop';
import { CommonProvider } from './context/AppContext';
import { installRequestDedupe } from './utils/requestDedupe';
import { expandShortProductLink } from './utils/shortProductLink';
import { rememberPromoCodeFromUrl } from './utils/getPromoCodeFromUrl';

// Collapses duplicate in-flight reads (allowlisted endpoints only) before any
// component mounts, so sibling components asking the same question share one request.
installRequestDedupe();

// Turns a short share link (/creator/dm_10 or ?p=dm_10) back into the deep-link
// params the storefront reads. Must happen before BrowserRouter mounts,
// otherwise the router keeps the un-expanded path and search string.
expandShortProductLink();

// The app rewrites the address when it opens a product and drops ?promo_code=
// on the way, so the checkout would never see it. Remember it now, before
// anything can rewrite the address; getPromoCodeFromUrl() hands it back.
rememberPromoCodeFromUrl();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CommonProvider>
      <App />
      <ScrollToTop />
    </CommonProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
